"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function TabVideowallSettings(_a) {
    var url = _a.url;
    var scriptUrl = "<script type=\"text/javascript\" src=\"" + url + "\"></script>";
    var ButtonCopy = storybook_1.Hooks.useCopy(scriptUrl, 'textarea')[0];
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storybook_1.Forms.Field, null,
            react_1.default.createElement(storybook_1.Forms.Label, { type: 'lg' }, "Embed code"),
            react_1.default.createElement(storybook_1.Texts.Small, { className: 'mb-4' }, "Plaats de onderstaande embed code in je website of app om de videowall van je kanaal te embedden."),
            react_1.default.createElement("div", { className: 'bg-white' },
                react_1.default.createElement(ButtonCopy, null))));
}
exports.default = TabVideowallSettings;
